import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.webp";

const Navigation = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar navbar-expand-lg sticky-top shadow-sm border-bottom"  style={{
    background: "linear-gradient(90deg, #4A90E2 , #9013FE)",
  }}>
      <div className="container">
        {/* Brand / Logo */}
        <Link to="/" className="navbar-brand d-flex align-items-center text-light fw-bold fs-3">
  <img
    src={logo}
    alt="Logo"
    style={{ height: "40px", width: "40px", marginRight: "10px", borderRadius: "50%" }}
  />
  FIND ME
</Link>
        {/* Mobile Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" style={{ filter: "invert(1)" }}></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav gap-3">
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link fw-semibold text-light ${isActive("/") ? "fw-bold border-light" : ""}`}
              
              >
                Home
              </Link>
            </li>
            {/* Services Dropdown */}
            <li className="nav-item dropdown">
              <Link
                 className={`nav-link fw-semibold text-light ${isActive("/") ? "fw-bold border-light" : ""}`}
                to="#"
                id="servicesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                
              >
                Services +
              </Link>
              <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                <li>
                  <Link className="dropdown-item" to="/services">
                    Services
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/services-details">
                    Services Details
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <Link
                className={`nav-link fw-semibold text-light ${isActive("/") ? "fw-bold border-light" : ""}`}
                to="#"
                id="portfolioDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Portfolio +
              </Link>
              <ul className="dropdown-menu" aria-labelledby="portfolioDropdown">
                <li>
                  <Link className="dropdown-item" to="/portfolioPage">
                    Portfolio 
                  </Link>
                </li>
                <li>
                  <li>
  <Link className="dropdown-item" to="/portfolio-details">
    Portfolio Details
  </Link>
</li>

                </li>
              </ul>
            </li>

            {/* Team Dropdown */}
            <li className="nav-item dropdown">
              <Link
                 className={`nav-link fw-semibold text-light ${isActive("/") ? "fw-bold border-light" : ""}`}
                to="#"
                id="teamDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Team +
              </Link>
              <ul className="dropdown-menu" aria-labelledby="teamDropdown">
                <li>
                  <Link className="dropdown-item" to="/team">
                    Team
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/member/1">
                    Team Details
                  </Link>
                </li>
              </ul>
            </li>

           

             <li className="nav-item">
  <Link
    to="/contact" // ✅ correct route
    className={`nav-link fw-semibold text-light ${isActive("/contact") ? "fw-bold border-light" : ""}`}
  >
    Contacts
  </Link>
</li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;


